// Request bodies for AI requests. The server builds the prompts from these fields; the client must never
// send a system message or a messages array.
export const createPersonExtractionRequest = (transcript) => ({
  task: 'personExtraction',
  transcript,
})

export const createRelationshipLinkingRequest = (transcript, persons) => ({
  task: 'relationshipLinking',
  transcript,
  persons,
})

// Reads an answer that has plain JSON instead of a ```json block. The prompts ask for the block, but the model does
// not always add one. An answer with an unclosed block was cut off, so it is not read.
function parsePlainJson(text) {
  if (text.includes('```')) return null
  const start = text.search(/[[{]/)
  const end = Math.max(text.lastIndexOf(']'), text.lastIndexOf('}'))
  if (start === -1 || end < start) return null
  return JSON.parse(text.slice(start, end + 1))
}

export function extractAndParseJson(text) {
  try {
    // Check if the input contains multiple JSON blocks
    const jsonBlocks = text.match(/```json(.*?)```/gs)
    if (!jsonBlocks) {
      const plainJson = parsePlainJson(text)
      if (plainJson !== null) return plainJson
      throw new Error('No valid JSON found')
    }
    if (jsonBlocks.length > 1) {
      // Parse each JSON block and combine them into an array
      return jsonBlocks.map((block) => {
        const jsonString = block.replace(/```json|```/g, '').trim()
        return JSON.parse(jsonString)
      })
    }
    if (jsonBlocks[0]) {
      return JSON.parse(jsonBlocks[0].replace(/```json|```/g, '').trim())
    }
    throw new Error('No valid JSON found')
  } catch (error) {
    console.error('Error extracting or parsing JSON:', error.message)
    return null
  }
}
